<template>
    <div>


        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "attendanceManagement",
    }
</script>

<style lang="scss" scoped>

</style>